// extracted by mini-css-extract-plugin
export default {"back-btn-sp":"BackNumber_back-btn-sp__Pz8KT","back-btn-pc":"BackNumber_back-btn-pc__V3oY8"};